import React, { cloneElement, FC, ReactElement, useMemo } from "react";
import { Transition } from "react-transition-group";

import { TransitionProps } from "../types";

interface IScale extends TransitionProps {
  children: ReactElement;
}

const transitionStyles = {
  entered: { transform: "scale(1)" },
  exiting: { transform: "scale(0)" },
};

export const Scale: FC<IScale> = ({
  in: inProp = false,
  onEnter,
  onExited,
  children,
  style,
  timeout = 200,
}) => {
  const defaultStyle = useMemo(() => {
    return {
      transitionProperty: "transform",
      transitionDuration: `${timeout}ms`,
      transform: "scale(0)",
    };
  }, [timeout]);

  return (
    <Transition
      in={inProp}
      timeout={timeout}
      onEnter={onEnter}
      onExited={onExited}
    >
      {(state): ReactElement => {
        return cloneElement(children, {
          style: {
            ...defaultStyle,
            ...transitionStyles[state],
            ...style,
            ...children.props.style,
          },
        });
      }}
    </Transition>
  );
};

Scale.displayName = "Scale";
